import React, { useEffect, useState } from "react";
import { ChatHeader } from "../ChatHeader/ChatHeader";
import ChatLeft from "../ChatLeft/ChatLeft";
import ChatRight from "../ChatRight/ChatRight";
import ChatWriter from "../ChatWriter/ChatWriter";
import { TicketsStyle } from "./TicketsStyle";
import { useParams } from "react-router-dom";
import {
  useChangeDepartment,
  useGetDepartementList,
  useGetTicketsChat,
  useReferTicket,
} from "../../hooks/useManagement";
import Loading from "../Loadings/LoadingTable";
import { useRef } from "react";
import Typography from "../Typography/Typography";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import Button from "../Button/Button";
import { CloseTicketModal } from "../Dialog/CloseTicketModal";
import { useGetCompanyUsers, useGetCustomer } from "../../hooks/useCrm";
import { Badge } from "react-bootstrap";
const initvalue = {
  ticket_id: null,
  department_id: null,
};

const Tickets = () => {
  const { id } = useParams();
  const [form, setForm] = useState(initvalue);

  const local = JSON.parse(localStorage.getItem("profile"));
  const idLoggedIn = local?.users[0]?.IdUser;
  const [referForm, setReferForm] = useState({
    ticket_id: null,
    user_ref_id: null,
  });
  const [show, setShow] = useState(false);
  const {
    data: chats,
    isLoading,
    refetch,
    isRefetching,
  } = useGetTicketsChat({ ticket_id: id });

  const { mutateAsync: referTicket } = useReferTicket();

  const { data: customerresponsible, isLoading: responsibleLoading } =
    useGetCompanyUsers();

  const customerResponsible = customerresponsible?.data?.ManagersAndColleagues;

  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });

  const bottomref = useRef(null);

  const chatStatus = chats?.data?.Ticket?.StatusTicket;

  const chatDetail = chats?.data?.Ticket;

  useEffect(() => {
    bottomref.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats]);

  const chat = chats?.data?.chats?.map((chat, index) => {
    if (chat.IdUser !== idLoggedIn) {
      return <ChatLeft data={chat} key={index} />;
    }
    if (chat.IdUser === idLoggedIn) {
      return <ChatRight data={chat} key={index} />;
    }
  });
  const {
    data: departement,
    isLoading: DepartementLoading,
    refetch: departmentFetching,
  } = useGetDepartementList();
  const Departements = departement?.data?.Departments;
  const DepartementOption = Departements?.map((dep) => {
    return {
      value: dep.IdDepartment,
      label: dep.NameDepartment,
    };
  });

  useEffect(() => {
    setForm({ ...form, ticket_id: id });
    setReferForm({ ...referForm, ticket_id: id });
    refetch();
  }, [id]);
  const { mutateAsync: changeDepartment } = useChangeDepartment();
  const handleChangeDepartment = async (data) => {
    await changeDepartment(data).then(() =>
      setForm({ ...form, department_id: null })
    );
  };
  const placeholder = DepartementOption?.filter((item) =>
    item?.value === chatDetail?.IdDepartment ? item?.label : null
  );
  const handleReferTicket = async (data) => {
    await referTicket(data);
  };
  return (
    <TicketsStyle>
      <div className="row">
        <div className="col-xl-3 col-lg-4 col-12">
          <div className="ticket-detail">
            <Typography className="mb-4">
              موضوع :{" "}
              <span style={{ fontSize: "14px", color: "#686868" }}>
                {chatDetail?.SubjectTicket}
              </span>
            </Typography>
            <Typography className="mb-4">
              شناسه تیکت:{" "}
              <span style={{ fontSize: "14px", color: "#686868" }}>
                {chatDetail?.IdTicket}
              </span>
            </Typography>
            <Typography className="mb-4">
              ارسال کننده:{" "}
              <span style={{ fontSize: "14px", color: "#686868" }}>
                {(chatDetail?.creator?.FirstName
                  ? chatDetail?.creator?.FirstName
                  : "") +
                  " " +
                  (chatDetail?.creator?.LastName
                    ? chatDetail?.creator?.LastName
                    : "")}
              </span>
            </Typography>
            <Typography className="mb-4">
              وضعیت:{" "}
              <Badge
                style={{ fontSize: "14px" }}
                bg={chatDetail?.status?.color}
              >
                {chatDetail?.status?.text}
              </Badge>
            </Typography>
            {/* <Typography className="mb-4">ارجاع به:</Typography> */}
            {local.users[0].Status === "admin" ? (
              <div className="departmentselect ">
                <SimpleSelect1
                  label="دپارتمان"
                  res={DepartementOption}
                  isLoading={DepartementLoading}
                  onMenuOpen={departmentFetching}
                  loadingMessage={() => "در حال بارگزاری"}
                  className=""
                  onChange={(e) => {
                    setForm({ ...form, department_id: e.value });
                  }}
                  placeholder={
                    placeholder !== undefined && placeholder[0] !== undefined
                      ? placeholder[0].label
                      : ""
                  }
                />
                <Button
                  onclick={() => handleChangeDepartment(form)}
                  size="12px"
                  bgColor="#009ef7"
                  className="m-0 mt-2"
                  color="#fff"
                >
                  تغییر دپارتمان
                </Button>
              </div>
            ) : null}
            {local.users[0].Status === "admin" ? (
              <div className="departmentselect ">
                <SimpleSelect1
                  label="ارجاع به"
                  res={customerResponsibleOptions}
                  isLoading={responsibleLoading}
                  loadingMessage={() => "در حال بارگزاری"}
                  className=""
                  onChange={(e) =>
                    setReferForm({ ...referForm, user_ref_id: e.value })
                  }
                />
                <Button
                  onclick={() => handleReferTicket(referForm)}
                  size="12px"
                  bgColor="#50cd89"
                  className="m-0 mt-2"
                  color="#fff"
                >
                  ارجاع دادن
                </Button>
              </div>
            ) : null}
            <div className="w-100 mt-2 d-flex">
              <Button
                onclick={() => setShow(true)}
                bgColor="#f1416c"
                className="m-0"
                color="#fff"
                size="12px"
              >
                بستن تیکت
              </Button>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-8 col-12">
          {!isLoading ? (
            <>
              <div className="ticket-holder">
                <ChatHeader
                  data={"تیکت"}
                  ticket
                  DepartementOption={DepartementOption}
                  DepartementLoading={DepartementLoading}
                  departmentFetching={departmentFetching}
                  ticketId={id}
                  chatsRefetch={refetch}
                />
                <div className="chat-holder">
                  {chat}
                  <div ref={bottomref}></div>
                </div>
                {chatStatus !== 4 ? <ChatWriter data={chats} /> : null}
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <CloseTicketModal
        show={show}
        handleClose={() => setShow(false)}
        ticketId={id}
        chatsRefetch={refetch}
      />
    </TicketsStyle>
  );
};

export default Tickets;
